import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import swipeSelectors from 'redux/selectors/SwipeSelectors'
import i18n from 'services/i18n'
import { FILTERS } from 'constants/urls'

import s from './AppliedFiltersBanner.module.scss'

const AppliedFiltersBanner = ({ isAnySearchApplied, history }) => {
  if (!isAnySearchApplied) {
    return null
  }

  const handleFiltersClick = () => {
    history.push(FILTERS)
  }

  return (
    <div className={s.banner}>
      <p className={s.text}>
        {i18n.t('filters.hiddenProfilesMessage')}{' '}
        <button
          className={s.link}
          onClick={handleFiltersClick}
          aria-label={i18n.t('filters.viewAppliedFilters')}
        >
          {i18n.t('filters.appliedFilters')}
        </button>
      </p>
    </div>
  )
}

AppliedFiltersBanner.propTypes = {
  isAnySearchApplied: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired
}

const mapStateToProps = createStructuredSelector({
  isAnySearchApplied: swipeSelectors.isAnySearchSelector
})

export default connect(mapStateToProps)(AppliedFiltersBanner)

